export default __webpack_public_path__ + "static/apps-cf31222b9c8a5ac1135c360485cdb257.png";